import { render, staticRenderFns } from "./AddForm.vue?vue&type=template&id=24801552&scoped=true"
import script from "./AddForm.vue?vue&type=script&lang=js"
export * from "./AddForm.vue?vue&type=script&lang=js"
import style0 from "./AddForm.vue?vue&type=style&index=0&id=24801552&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24801552",
  null
  
)

export default component.exports